import React from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
const testimonials = [{
  text: 'Desde la primera sesión sentí mi piel más calmada y con brillo natural. Cindy explica todo y te hace sentir en confianza.',
  author: 'Valentina R.'
}, {
  text: 'Me encantó el detalle y la higiene. Salí con la piel suave y con una sensación de paz increíble.',
  author: 'Mariana L.'
}, {
  text: 'Lo mejor es que no te promete magia: te guía con hábitos y el resultado se nota semana tras semana.',
  author: 'Andrea P.'
}, {
  text: 'El ambiente es hermoso y Cindy tiene manos y energía súper suaves. Me sentí cuidada.',
  author: 'Carolina M.'
}, {
  text: 'Nunca había entendido mi piel hasta que fui con Cindy. Ahora mi rutina tiene sentido y mi piel se ve más pareja.',
  author: 'Gabriela S.'
}, {
  text: 'Profesional, delicada y muy clara. Recomendada si quieres verte bien sin perder lo natural.',
  author: 'Sofia T.'
}];
export function Testimonials() {
  return <section className="py-20 md:py-32 bg-ivory-dark overflow-hidden" data-id="element-154">
      <div className="max-w-7xl mx-auto px-6" data-id="element-155">
        <div className="text-center mb-16" data-id="element-156">
          <h2 className="text-4xl md:text-5xl font-serif text-softBlack mb-4" data-id="element-157">
            Testimoniales
          </h2>
          <p className="text-warmGray font-light" data-id="element-158">
            Lo que dicen nuestras clientas
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-159">
          {testimonials.map((testimonial, index) => <motion.div key={index} initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1,
          duration: 0.6
        }} className={`bg-white p-8 rounded-2xl shadow-sm hover:shadow-md transition-all duration-300 ${index % 2 === 0 ? 'md:rotate-1' : 'md:-rotate-1'} hover:rotate-0`} data-id="element-160">
              <div className="flex gap-1 mb-6" data-id="element-161">
                {[...Array(5)].map((_, i) => <Star key={i} size={16} className="fill-gold text-gold" data-id="element-162" />)}
              </div>
              <p className="text-warmGray italic mb-6 leading-relaxed font-light" data-id="element-163">
                "{testimonial.text}"
              </p>
              <p className="font-serif text-softBlack font-medium" data-id="element-164">
                — {testimonial.author}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}